import { theme, useResponsive } from "@product/scmp-sdk";
import type { FunctionComponent, ReactNode } from "react";

import { useContentReadMoreContext } from "~/components/content/content-read-more/contexts";

type Props = {
  children?: ReactNode;
};

export const ContentReadMoreChecker: FunctionComponent<Props> = ({ children }) => {
  const { isClicked } = useContentReadMoreContext();
  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false, {
    initializeWithValue: true,
  });
  return isClicked || !isMobile ? <>{children}</> : null;
};

ContentReadMoreChecker.displayName = "ContentReadMoreChecker";
